var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplay = function SvgReplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "live_tv_black_24dp",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70740",
    "data-name": "Path 70740",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70741",
    "data-name": "Path 70741",
    d: "M21,6H13.41l2.94-2.94a.5.5,0,0,0-.71-.71L12,5.99,8.36,2.35a.5.5,0,0,0-.71.71L10.59,6H3A2,2,0,0,0,1,8V20a2.006,2.006,0,0,0,2,2H21a2.006,2.006,0,0,0,2-2V8A2,2,0,0,0,21,6ZM20,20H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H20a1,1,0,0,1,1,1V19A1,1,0,0,1,20,20Z",
    fill: "#505c7c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "replay-24px",
    d: "M6.808,2.845V1.882a.171.171,0,0,0-.293-.121L5.2,3.069a.171.171,0,0,0,0,.245L6.511,4.622a.175.175,0,0,0,.3-.124V3.535A2.071,2.071,0,1,1,4.758,5.9a.345.345,0,0,0-.683.1A2.764,2.764,0,1,0,6.808,2.845Z",
    transform: "translate(5.179 8.928)",
    fill: "#505c7c"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replay.e86f9a19.svg";
export { ForwardRef as ReactComponent };